<template>
  <Field
    :as="cssClass ? 'div' : null"
    class="input"
    :class="cssClass"
    :name="innerName"
    :label="label"
    :type="type"
    :rules="rules ?? ''"
    v-slot="{ field, meta, errorMessage }"
  >
    <!--    <pre style="font-size: small;background: #f0fff4;overflow-x: scroll;">{{ meta }}</pre>-->
    <label
      class="input__label"
      :class="{
        'input__label--as-placeholder': !placeholder && !focus && !field.value,
        'input__label--only': !(!placeholder && !focus && !field.value),
        'input__label--only-mobile': labelType === 'only-mobile',
        'input__label--required': isRequired
      }"
      v-if="label"
      :for="getInputId()"
    >
      {{ label }}
    </label>
    <div
      class="input__wrapper"
      :class="{
        'input__wrapper--focus': focus,
        'input__wrapper--error': !!errorMessage,
        'input__wrapper--valid': meta.valid
      }"
    >
      <input
        v-bind="field"
        class="input__field"
        :type="innerType"
        :placeholder="inputPlaceholder"
        @focus="focusHandler"
        @blur="blurHandler"
        :disabled="disabled"
        :min="min"
        :max="max"
        :step="step"
        :autocomplete="autocomplete || null"
        ref="inputField"
        :id="getInputId()"
        @keyup="$emit('keyUpEvent')"
        @change="$emit('change')"
        :aria-errormessage="!!errorMessage ? getInputId('-error') : null"
        :aria-invalid="!!errorMessage"
        :aria-label="ariaLabel || null"
      >
      <button
        v-if="type === 'search'"
        :class="[focus ? 'input__close-icon__active' : 'input__close-icon__not-active']"
        class="input__close-icon"
        @click.prevent="resetInputValue"
        :aria-label="$('global.search.close.btn.aria.label')"
        type="button"
      />
      <button
        v-if="button"
        class="input__button"
        :type="button.type"
        :class="[{
          'input__button--default': (button.type && button.type === 'default') || !button.type,
          'input__button--icon_eye': innerType === 'password' && !passwordToggled,
          'input__button--icon_eye-blocked': innerType === 'text' && passwordToggled
        }, buttonIconClass(button.icon)]"
        :aria-label="labelForButton(button.icon)"
        @click="event => buttonClickHandler(event)"
      >
        <span
          v-if="button.text"
          class="input__button-text"
        >
          {{ button.text }}
        </span>
      </button>
    </div>

    <ErrorMessage
      v-if="!suppressErrorMessages"
      as="span"
      class="input__error | input-error"
      :name="innerName"
      :id="getInputId('-error')"
    />
  </Field>
</template>

<script>
import {ErrorMessage, Field} from 'vee-validate'
import randomId from '../../utilities/js/randomId/randomId';

export default {
  components: {ErrorMessage, Field},
  props: {
    name: {
      type: String,
      default: ''
    },
    rules: {
      type: [String, Object],
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'text'
    },
    labelType: {
      type: String,
      default: ''
    },
    button: {
      type: {
        type: String,
        icon: String,
        text: String,
      },
      default: null
    },
    placeholder: {
      type: String,
      default: ''
    },
    cssClass: {
      type: String,
      default: null,
    },
    autocomplete: String,
    suppressErrorMessages: {
      type: Boolean,
      default: false,
    },
    autoCompleteValue: String,
    min: Number,
    max: Number,
    step: Number,
    id: String,
    ariaLabel: String,
  }
  ,
  data() {
    return {
      focus: false,
      innerName: this.name,
      innerType: this.type,
      passwordToggled: false,
      randomId: randomId(true)
    }
  }
  ,
  computed: {
    isRequired() {
      if (typeof this.rules === 'object') {
        return this.rules.required
      }
      return this.rules?.includes('required')
    }
    ,
    inputPlaceholder() {
      return this.focus ? '' : (this.placeholder || this.label) + (this.isRequired ? ' *' : '')
    }
    ,
  }
  ,
  emits: ['blur', 'buttonclicked', 'resetInput', 'keyUpEvent', 'change'],
  methods:
    {
      blurHandler() {
        this.focus = false
        this.$emit('blur')
      }
      ,
      focusHandler() {
        this.focus = true
      }
      ,
      buttonClickHandler(event) {
        if (this.$props.button?.type === 'submit') {
          return
        }

        event.preventDefault()

        if (this.innerType === 'password' && !this.passwordToggled) {
          this.innerType = 'text'
          this.passwordToggled = true
        } else if (this.innerType === 'text' && this.passwordToggled) {
          this.innerType = 'password'
          this.passwordToggled = false
        } else {
          this.$emit('buttonclicked')
        }
      }
      ,
      getValue() {
        return this.value
      }
      ,
      buttonIconClass(icon) {
        return icon ? 'input__button--icon_' + icon : ''
      }
      ,
      labelForButton(icon) {
        if (icon === 'mail') {
          return this.$t('newsletter.sub.button.label')
        } else if (icon === 'search') {
          return this.$t('search.button.label')
        } else if (this.innerType === 'password' && !this.passwordToggled) {
          return this.$t('password.plain.text.button.label')
        } else if (this.innerType === 'text' && this.passwordToggled) {
          return this.$t('password.hide.text.button.label')
        } else {
          return ''
        }
      }
      ,
      resetInputValue() {
        this.$refs.inputField.focus()
        this.$emit('resetInput')
      }
      ,
      setFocus() {
        this.$refs.inputField.focus()
      },
      getInputId(postfix = '') {
        return `input-${this.randomId}-${this.type}-${this.name}${postfix}`;
      }
    }
}

</script>
